import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch LGA options
export const fetchLGAOptions = createAsyncThunk(
  'landSearch/fetchLGAOptions',
  async (endpoint, thunkAPI) => {
    try {
      const response = await fetch(`${endpoint}/LGAoptions`);
      const data = await response.json();
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: {
    Land_No: '',
    Block_No: '',
    LGA: '',
    SurveyPlan_No: '',
    CofO_No: '',
  },
  ModuleName: '',
  additionalSearch: [
    { SearchKey: "ONLINE_LAND_SEARCH" },
    { SearchKey: "LAND_REGISTER_FEE" },
  ],
  paramsData: [
    { FieldName: "Land_No", FieldType: "String" },
    { FieldName: "Block_No", FieldType: "String" },
    { FieldName: "LGA", FieldType: "String" },
    { FieldName: "SurveyPlan_No", FieldType: "String" },
    { FieldName: "CofO_No", FieldType: "String" },
  ],
  errors: {},
   errorMessage: "",
  isSuccessUpdate: false,
  successMessage: "",
  options: [],
  selectedValue: '',
  stage: 1,
  show: 'searchForm',
  errorTitle: "",
  errorLinkTo: "",
  errorLinkTitle: "",
  errorLinkClassName: "",
  ownerId: "",
  webUserId: "",
  receiptId: 0,
  billingDetails: "",
  /*FirstName: "",
  LastName: "",
  Email: "",
  IDNumber: "",
  IDType: "",*/
  isFlushed: false,
  searchResult: undefined,
  additionSearchResults: undefined,
  paymentResult: undefined,
  prevStage: null,
  nextStage: "searchResults"
};

const landSearchSlice = createSlice({
  name: 'landSearch',
  initialState,
  reducers: {
        setDataField: (state, action) => {
            const { field, value } = action.payload;
            state.data[field] = value;
        },
        setModuleName: (state, action) => {
            state.ModuleName = action.payload;
        },
        setReceiptId: (state, action) => {
            state.receiptId = action.payload;
        },
        setFirstName: (state, action) => {
            state.FirstName = action.payload;
        },
        setLastName: (state, action) => {
            state.LastName = action.payload;
        },
        setEmail: (state, action) => {
            state.Email = action.payload;
        },
        setIDNumber: (state, action) => {
            state.IDNumber = action.payload;
        },
        setIDType: (state, action) => {
            state.IDType = action.payload;
        },
        setErrors: (state, action) => {
            const { field, value } = action.payload;
            state.errors[field] = value;
        },
        setOptions: (state, action) => {
            state.options = action.payload;
        },
        setSelectedValue: (state, action) => {
            state.selectedValue = action.payload;
        },
        clearAllErrors: (state) => {
            state.errors = {};
        },
        setErrorState(state, action) {
            const { errorTitle, errorMessage, errorLinkTo, errorLinkTitle, errorLinkClassName, prevStage } = action.payload;
            state.errorTitle = errorTitle;
            state.errorMessage = errorMessage;
            state.errorLinkTo = errorLinkTo;
            state.errorLinkTitle = errorLinkTitle;
            state.errorLinkClassName = errorLinkClassName;
            state.prevStage = prevStage;
        },
        setErrorTitle: (state, action) => {
            state.errorTitle = action.payload;
        },
        setErrorLinkTo: (state, action) => {
            state.errorLinkTo = action.payload;
        },
        seterrorLinkTitle: (state, action) => {
            state.errorLinkTitle = action.payload;
        },
        seterrorLinkClassName: (state, action) => {
            state.Email = action.payload;
        },
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload;
        },
        setSuccessMessage: (state, action) => {
            state.successMessage = action.payload;
        },
        setIsSuccessUpdate: (state, action) => {
            state.isSuccessUpdate = action.payload;
        },
        setIsFlushed: (state, action) => {
            state.isFlushed = action.payload;
        },
        setAdditionSearchResults: (state, action) => {
            state.additionSearchResults = action.payload;
        },
        setSearchResult: (state, action) => {
            state.searchResult = action.payload;
        },
        setPaymentResult: (state, action) => {
            state.paymentResult = action.payload;
        },
        initializeFromProps: (state, action) => {
            const { land_no, block_no, LGA, SurveyPlan_No, CofO_No, moduleName } = action.payload;
             state.data = {
                Land_No: land_no || '',
                Block_No: block_no || '',
                LGA: LGA || '',
                SurveyPlan_No: SurveyPlan_No || '',
                CofO_No: CofO_No || ''
            };
            state.selectedValue = LGA || '';
            state.ModuleName = moduleName || '';
        },
        setStage(state, action) {
            state.stage = action.payload;
        },
        setNextStage(state, action) {
            state.nextStage = action.payload;
        },
        setPrevStage(state, action) {
            state.prevStage = action.payload;
        },
        setShow(state, action) {
            state.show = action.payload;
        },
        resetState: (state) => {
            return initialState; // Resets to the original slice state
        }
    },
    extraReducers: (builder) => {
        builder
      .addCase(fetchLGAOptions.fulfilled, (state, action) => {
        state.options = action.payload;
      })
      .addCase(fetchLGAOptions.rejected, (state, action) => {
        console.error("Failed to fetch LGA options:", action.payload);
      });
  }
});

export const {
  setPrevStage, 
  setNextStage,
  setReceiptId,
  setErrorState,
  seterrorLinkClassName,
  setErrorTitle,
  setErrorLinkTo,
  seterrorLinkTitle,
  setFirstName,
  setLastName,
  setEmail,
  setIDNumber,
  setIDType,
  setPaymentResult,
  setAdditionSearchResults,
  setSearchResult,
  setIsFlushed,
  setStage,
  setShow,
  setDataField,
  setModuleName,
  setErrors,
  setOptions,
  setSelectedValue,
  setSuccessMessage, 
  setErrorMessage,
  setIsSuccessUpdate,
  initializeFromProps,
  clearAllErrors,
  resetState
} = landSearchSlice.actions;

export default landSearchSlice.reducer;

//SELECTORS
export const selectLandSearch = (state) => state.landSearch;
